/** @flow */
import type { State } from "@store/reducers";
import type { PaginationExtendedType, SortOrder } from "@types";
import type {
  Advisor,
  AdvisorsFilters,
  AdvisorActivity,
  AdvisorActivityFilters,
} from "@modules/management/types";
import { getPagination } from "@selectors";

export const selectAdvisor = (state: State): Advisor | null => state.management.advisors.current;

export const selectAdvisors = (state: State): Array<Advisor> => state.management.advisors.content;

export const selectAdvisorActivity = (state: State): Array<AdvisorActivity> =>
  state.management.advisorActivity.content;

export const selectAdvisorActivityFilters = (state: State): AdvisorActivityFilters | {} => {
  return (state.form["advisor-activity-filters"] || {}).values || {};
};

export const selectAdvisorsPagination = (state: State): PaginationExtendedType =>
  getPagination((state.management || {}).advisors);

export const selectAdvisorsPage = (state: State): number | null =>
  selectAdvisorsPagination(state).pageNumber;

export const selectAdvisorsSort = (state: State): Array<SortOrder> | null =>
  ((((state.management || {}).advisors || {}).pagination || {}).sort || {}).orders;

export const selectAdvisorsFilters = (state: State): AdvisorsFilters =>
  (state.form["advisors-filters"] || {}).values || {};

export const selectAdvisorName = (advisor: Advisor | null): string =>
  `${(advisor || {}).firstName || ""} ${(advisor || {}).lastName || ""}`;

export const selectAdvisorActivityPagination = (state: State): PaginationExtendedType =>
  getPagination(state.management.advisorActivity);

export const selectAdvisorActivityPage = (state: State): number | null =>
  selectAdvisorActivityPagination(state).pageNumber;
